var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitCommit = function SvgGitCommit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.999 8.283a3.72 3.72 0 0 1 3.668 3.116h5.684a.6.6 0 0 1 0 1.2h-5.684a3.718 3.718 0 0 1-7.336 0H2.648a.6.6 0 1 1 0-1.2h5.683a3.72 3.72 0 0 1 3.668-3.116m0 1.199a2.517 2.517 0 1 0 0 5.034 2.517 2.517 0 0 0 0-5.034"
  })));
};
export default SvgGitCommit;